export const somenteNumeros = (str) => {
    return (str) ? str.replace(/\D+/g, '') : ''
}

export const somenteAlpha = (str) => {
	return (str) ? str.replace(/[^A-Za-z0-9]/g, '') : ''
}

export const preencherNumeroProcessoComZeroEsquerda = (str) => {
    const tamanhoPadraoCampoNumeroProcesso = 20
    return (str) ? str.padStart(tamanhoPadraoCampoNumeroProcesso, '0') : ''
}

export const formatarNumeroProcesso = (str) => {
	if(!str) {
		return ''
	}
	const tamanhoPadraoCampoNumeroProcesso = 20
	str = str.padStart(tamanhoPadraoCampoNumeroProcesso, '0')
	return str.replace(/^(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})/, '$1-$2.$3.$4.$5.$6')
}

export const textoComReticencias = (texto, limite) => {
	let txt = texto
	if((texto) && (texto.length > 0) && (Number.isInteger(limite)) && (limite >= 0)) {
		if(texto.length > limite) {
			txt = txt.substring(0, limite) + '...'
		}
	}
	return txt;
}